import { usePageData } from "@wss/react";
import {
  AdvertisementItem,
  BannerItem,
  BestSellingProductsCarousel,
  BrandItem,
  FoodServiceResource,
  HomePageFeaturedCarousel,
} from "./HomePageResult";

export interface HomePageData {
  header: string;
  banner: BannerItem[];
  restaurantBrands: BrandItem[];
  advertisements: AdvertisementItem[];
  carousel: HomePageFeaturedCarousel;
  bestSellingProductsCarousel: BestSellingProductsCarousel;
  resources: FoodServiceResource[];
}

export function useHomePageData(): HomePageData {
  return usePageData("HomePage");
}
